import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'yes_how_many_cases_was_victim_female_worker_3'

export const dataPointDefinition = {
  retracedId: 'yes_how_many_cases_was_victim_female_worker_3',
  name: 'If yes, in how many cases was the victim a female worker?',
  description: '',
  meta: {
    slcpMeta: {
      key: 'wt-har-6',
      number: 'WT-HAR-14',
      dataType: 'numeric-whole',
      masterType: 'Question',
      multiSelectKey: '',
      optionList: '',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],hb-5,Yes',
      machineShowHide: '[2],hb-5,1',
      completionCondition: 'any',
    },
  },
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wt-har-6', version: '1.7.0', provider: 'slcp'}],
  sortingId: 37550,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
